import React from 'react'
import { MultiSelect } from 'react-selectize'
import { Control } from 'react-redux-form'

class MultiSelectControl extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      search: ''
    }
  }

  render() {
    const { model, createFromValue, children, ...rest } = this.props
    const { isOpen } = this.state
    const parent = this

    return (
      <Control.custom
        model={model}
        component={MultiSelect}
        getValue={e => e}
        isOpen={isOpen}
        mapProps={{
          onValuesChange: props => {
            const { onChange } = props

            return optionValues => {
              parent.setState({
                search: ''
              })
              console.log(
                'Calling onChange with',
                optionValues.map(o => o.value)
              )
              //debugger;
              onChange(optionValues.map(o => o.value))
            }
          },
          onOpenChange: props => {
            const delegate = props.onOpenChange

            return open => {
              //console.log("Setting open to", open);
              parent.setState({
                isOpen: open
              })
              delegate && delegate.onOpenChange(open)
            }
          },
          onSearchChange: props => {
            const { onSearchChange } = props

            return search => {
              parent.setState({
                search
              })
              onSearchChange && onSearchChange(search)
            }
          },
          search: parent.state.search,
          values: props => {
            //console.log("props =", props);
            const { viewValue } = props

            /*
             * console.log("state =", parent.state);
             * if(props.isOpen) {
             * console.log("showing value as null!")
             *     return null;
             * }
             */
            if (createFromValue && viewValue) {
              const created = createFromValue(viewValue)

              // console.log("created =", created, "form viewValue = ", viewValue);
              return created
            }

            return viewValue
          },
          style: props => {
            return props.style || { width: '100%' }
          }
        }}
        createFromValue={createFromValue}
        {...rest}>
        {children}
      </Control.custom>
    )
  }
}

export default MultiSelectControl
